import { useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { Link, useLocation, useParams } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";
import Panel from "../../../../components/panel/panel";
import EmailSendDays from "./EmailSendDays";
import EmailConfigSubject from "./EmailConfigSubject";
import { getSendDays } from "../../../../services/Enterprise/WhatsppConfig/getSendDays";
import { useQuery } from "react-query";
import usePermission from "../../../../hooks/usePermission";
import { useAppContext } from "../../../../context/AppContext";

const EmailConfig = () => {
  const { id } = useParams(); //get id
  const { state } = useLocation();
  const { permissions } = useAppContext();
  usePermission("91"); //Configurar Moddelos de Envio - Email

  const items = [
    {
      template: () => (
        <Link to={`/enterpriseSettings/${id}`} state={{ name: state ? state.name : "Empreendimento" }} className="p-breadcrumb-link">
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link to={`/emailShippingDays/${id}`} state={{ name: state ? state.name : "Empreendimento" }} className="p-breadcrumb-link">
          Configurações de Email
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const [objData, setObjData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const {
    data: send_days,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: [`send_days`],
    queryFn: () => getSendDays(1),
    enabled: !!permissions?.includes("91")
  });

  // Função para lidar com a alteração do estado do checkbox
  const handleCheckboxChange = (rowData) => {
    //    console.log(rowData);
    const updatedSendDays = send_days.map((day) => {
      if (day.id === rowData.id) {
        return {
          ...day,
          status: day.status == 1 ? 0 : 1, // Alternar o status entre 0 e 1
        };
      }
      // console.log(day);
      return day;
    });

    // Atualiza os dias de envio com a nova lista atualizada
    refetch();
  };

  return (
    <>
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>

      <Panel title="Configurar Modelos de Email">
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="meu-tabview pt-3"
        >
          <TabPanel
            header="Configurar Mensagem/ Dias de Envio"
            leftIcon="fa-regular fa-envelope mx-2"
          >
            <EmailSendDays
              send_days={send_days}
              isLoading={isLoading}
              id={id}
              objData={objData}
              refetch={refetch}
            />
          </TabPanel>
          <TabPanel
            header="Regras de Envios Cadastradas"
            leftIcon="fa-solid fa-paper-plane mx-2"
          >
            <EmailConfigSubject
              setObjData={setObjData}
              setActiveIndex={setActiveIndex}
              send_days={send_days}
              isLoading={isLoading}
              refetch={refetch}
              handleCheckboxChange={handleCheckboxChange} // Passando a função para o componente filho
            />
          </TabPanel>
        </TabView>
      </Panel>
    </>
  );
};

export default EmailConfig;
